export default {
  projectLang: {
    search: {
      projectCode: '项目编号',
      orderMakeTime: '制单日期',
      oprateMan: '操作人',
      applyDepartment: '申请部门',
      company: '公司',
      manager: '负责人',
      projectName: '项目名称',
      returnType: '业务类型',
      customerName: '客户名称',
      recycleCompany: '回收公司',
      platformCompany: '平台公司',
      province: '项目所属省份',
      city: '项目所属地市',
      companyProperty: '企业属性',
      usageQuota: '项目使用额度',
      receiveAmount: '项目应收账款额度',
      benegfitPoint: '项目收益点位',
      paymentDays: '项目账期',
      monthlyOutput: '月供货量',
      revenueTarget: '营业收入目标',
      biddingStatus: '招标状态',
      subjectMatter: '标的物',
      projectStatus: '项目状态',
      recycle: '回款周期',
      rule: '保供条款',
      paymentWay: '付款方式',
      bidPrice: '中标金额',
    },
    placeholder: {
      markPlaceholder: '请输入',
    },
    table: {
      orderNumber: '制单编号',
      businessType: '业务类型',
      projectName: '项目名称',
      customerName: '客户名称',
      applyDepartment: '申请部门',
      manager: '负责人',
      recycleCompany: '回收公司',
      projectStatus: '项目状态',
    },
  },
};
